import {NgModule} from '@angular/core';
import {DistributedStreamingRegistryService} from './distributed-streaming-registry.service';

@NgModule({
    providers: [
        DistributedStreamingRegistryService
    ]
})
export class StreamingModule {}
